export default __webpack_public_path__ + "static/media/networking.b1dded1a.png";